const SAMPLE_AREA_CODE = '333';

export const toSamplePhone = (lineNumber: string | number) =>
  `+1${SAMPLE_AREA_CODE}${String(lineNumber).replace(/\D/g, '').padStart(7, '0').slice(0, 7)}`;
